import React from "react";
import {
    Route,
    createBrowserRouter,
    createRoutesFromElements, RouterProvider,
} from "react-router-dom";
import {NotFound, WithoutStartup} from "../errorpage/ErrorPage.component.jsx";
import {RouteCrashFallback} from "../errorpage/AppErrorBoundary";
import RouteTracker from "./VirtualPageTracker.component";
import Logout from "../usercontext/LogoutPage.component";
import MyTasks from '../mytasks/MyTasks.component';
import MyHistory from "../myhistory/MyHistory.component";
import TaskDetailMasterLayer from "../taskdetails-remake/TaskDetailsMasterLayer.component.jsx";
import TaskDetailMasterLayerByUID from "../taskdetails-remake/TaskDetailsMasterLayerByUID.component.tsx";
import HistoryTaskDetail from "../historydetail/HistoryTaskDetail.component";
import ProcessDetailsMasterLayer from "../processdetail/TaskDetailsMasterLayer.component.jsx";
import ProcessDetailsMasterLayerByUID from "../processdetail/TaskDetailsMasterLayerByUID.component.tsx";
import TaskOverview from '../taskoverview/TaskOverview.component.jsx';
import DocumentOverview from '../documentoverview/DocumentOverview.component.jsx';
import DocumentTaskDetail from "../documentdetail/DocumentTaskDetail.component";
import ApproverNotifications from "../settings/ApproverNotifications.component";
import SubstituteSettings from "../settings/SubstituteSettings.component";
import OtherSettings from "../settings/OtherSettings.component.jsx";
import Configuration from "../configuration/Configuration.component";
import Workflows from "../workflows/Workflows.component";
import DueSettings from '../dueSettings/DueSettings.component';
import SubstitutesWrapper from "../substitutes/NewSubstitutes.component";
import ManagersWrapper from "../managers/NewManagers.component";
import WorkflowDetails from "../workflowdetails/WorkflowDetails.component";
import Departments from "../departments/Departments.component";
import CostUnits from "../costunits/CostUnits.component";
import RolesWrapper from "../roles/NewRoles.component";
import Projects from '../projects/Projects.component';
import OrganisationChart from "../organisationChart/OrganisationChart.component";
import PreApproval from "../preapproval/PreApproval.component";
import WorkflowDetailsHistory from "../workflowdetails/WorkflowDetailsHistory.component";
import {withRouteBlocker} from "components/router/withRouter";
import ProcessOverview from "components/processoverview/ProcessOverview.component.jsx";
import NewSettingsMainPage from "components/newSettings/Settings.main";
import Swagger from "components/common/Swagger.jsx";
import ApiToolPage from "../../API Tool/ApiTool.component.jsx";

export default function ApprovalRouter() {

    const TaskDetailsWithRouteBlocker = withRouteBlocker(TaskDetailMasterLayer);
    const TaskDetailsWithRouteBlockerByUID = withRouteBlocker(TaskDetailMasterLayerByUID);
    const ProcessDetailsWithRouteBlocker = withRouteBlocker(ProcessDetailsMasterLayer);
    const ProcessDetailsWithRouteBlockerByUID = withRouteBlocker(ProcessDetailsMasterLayerByUID);
    const HistoryDetailsWithRouteBlocker = withRouteBlocker(HistoryTaskDetail);
    const DocumentDetailsWithRouteBlocker = withRouteBlocker(DocumentTaskDetail);
    const ApproverNotificationsWithRouteBlocker = withRouteBlocker(ApproverNotifications);
    const SubstituteSettingsWithRouteBlocker = withRouteBlocker(SubstituteSettings);
    const OtherSettingsWithRouteBlocker = withRouteBlocker(OtherSettings);

    const DueSettingsWithRouteBlocker = withRouteBlocker(DueSettings);
    const CostUnitsWithRouteBlocker = withRouteBlocker(CostUnits);
    const WorkflowDetailsWithRouteBlocker = withRouteBlocker(WorkflowDetails);

    const router = createBrowserRouter(
        createRoutesFromElements(
            <Route path="/" element={<RouteTracker/>} errorElement={<RouteCrashFallback/>}>
                <Route exact path="/" element={<MyTasks/>}/>
                <Route exact path="/task/:taskId" element={<TaskDetailsWithRouteBlocker/>}/>
                <Route exact path="/tasks/:uid" element={<TaskDetailsWithRouteBlockerByUID/>}/>
                <Route path="preapproval" element={<PreApproval/>}/>
                <Route path="history" element={<MyHistory/>}/>
                <Route path="taskhistory/:taskId" element={<HistoryDetailsWithRouteBlocker/>}/>
                <Route path="processoverview" element={<ProcessOverview/>}/>
                <Route path="processtask/:taskId" element={<ProcessDetailsWithRouteBlocker/>}/>
                <Route path="processes/:uid" element={<ProcessDetailsWithRouteBlockerByUID/>}/>
                <Route path="taskoverview" element={<TaskOverview/>}/>
                <Route path="documentoverview" element={<DocumentOverview/>}/>
                <Route path="document/:taskId" element={<DocumentDetailsWithRouteBlocker/>}/>

                <Route index path="settings" element={<NewSettingsMainPage/>}/>

                <Route path="configuration">
                    <Route index element={<SubstitutesWrapper/>}/>
                    <Route path="substitutes" element={<SubstitutesWrapper/>}/>
                    <Route path="oldsettings" element={<Configuration/>}/>
                    <Route path="workflows" element={<Workflows/>}/>
                    <Route path="workflows/workflow/:workflowId" element={<WorkflowDetailsWithRouteBlocker/>}/>
                    <Route path="workflows/workflowHistory/:workflowId/:version" element={<WorkflowDetailsHistory/>}/>
                    <Route path="dueSettings" element={<DueSettingsWithRouteBlocker/>}/>
                    <Route path="roles" element={<RolesWrapper/>}/>
                    <Route path="managers" element={<ManagersWrapper/>}/>
                    <Route path="departments" element={<Departments/>}/>
                    <Route path="projects" element={<Projects/>}/>
                    <Route path="costUnits" element={<CostUnitsWithRouteBlocker/>}/>
                    <Route path="organisationChart" element={<OrganisationChart/>}/>
                </Route>


                {/*
                  * Internal tools. Each page renders NotFound unless the fe-api-tool flag is on - the
                  * gate is inside the page, since the router is built above AppInitialization. The
                  * index route gives /tools somewhere to land, as /configuration has.
                  */}
                <Route path="tools">
                    <Route index element={<ApiToolPage/>}/>
                    <Route path="api" element={<ApiToolPage/>}/>
                    <Route path="swagger" element={<Swagger/>}/>
                </Route>

                <Route path="logout" element={<Logout/>}/>
                <Route path="/error" element={<WithoutStartup/>}/>
                <Route path="*" element={<NotFound/>}/>
            </Route>
        )
    );

    return <RouterProvider router={router}/>
}